















































import { MedidasProdutosEnteralResult } from '@/interfaces/product';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';

@Component({
  components: {
    GChart,
  },
})
export default class PrescriptionEnteralDetails extends BaseComponent {
  @Prop()
  private show: boolean
  @Prop()
  private result: MedidasProdutosEnteralResult;

  public headers: any = [
    { text: 'Produto', sortable: false },
    { text: 'Insumo', sortable: false },
    { text: 'Enteral efetivo', align: 'center', sortable: false },
    { text: 'Termogênese', align: 'center', sortable: false },
    { text: 'Parenteral', align: 'center', sortable: false },
    { text: 'Total', align: 'center', sortable: false },
  ];

  private getDadosCalculo() {
    let dados = [];
    if (!this.result) {
      return [];
    }

    this.pushNomeValor('Enteral', this.result.nomeEnteral, dados);
    this.pushNomeValor('Quantidade Enteral', this.decimalFormatHelper(this.result.qtdeEnteralMl) + ' mL', dados);
    this.pushNomeValor('Tipo de Cálculo', this.result.tipoCalculo.nome, dados);
    this.pushNomeValor('Correção Enteral', this.decimalFormatHelper(this.result.fatorCorrecaoNE, 5), dados);
    this.pushNomeValor('Correção Parenteral', this.decimalFormatHelper(this.result.fatorCorrecaoNP, 5), dados);
    this.pushNomeValor('Fator de Suspensão', this.decimalFormatHelper(this.result.fatorSuspensao, 0) + ' %', dados);
    this.pushNomeValor('Fator de Termogênese', this.decimalFormatHelper(this.result.fatorTermogenese, 0) + ' %', dados);
    this.pushNomeValor('Peso considerado', this.decimalFormatHelper(this.result.pesoPacienteUsado, 2) + ' kg', dados);
    this.pushNomeValor('Objetivo Calórico', this.decimalFormatHelper(this.result.objetivoCalorico, 0) + ' kcal/kg/dia', dados);
    this.pushNomeValor('Objetivo Calórico Paciente', this.decimalFormatHelper(this.result.objetivoCaloricoPeso, 2) + ' kcal/dia', dados);
    this.pushNomeValor('Oferta Calórica Enteral', this.decimalFormatHelper(this.result.ofertaCaloricaNE, 2) + ' kcal/dia', dados);
    this.pushNomeValor('Oferta Calórica Enteral Efetiva', this.decimalFormatHelper(this.result.ofertaCaloricaEfetivaNE, 2) + ' kcal/dia', dados);
    this.pushNomeValor('Termogênese Enteral', this.decimalFormatHelper(this.result.termogeneseNE, 2) + ' kcal/dia', dados);
    this.pushNomeValor('Volume Enteral', this.decimalFormatHelper(this.result.volumeNE, 2) + ' mL', dados);
    this.pushNomeValor('Volume Desejado', this.decimalFormatHelper(this.result.volumeNP, 2) + ' mL', dados);
    this.pushNomeValor('Volume Parenteral', this.decimalFormatHelper(this.result.volumeFinal, 2) + ' mL', dados);
    this.pushNomeValor('Parenteral deve ser suspenso', this.result.suspender ? 'Sim' : 'Não', dados);
    if (this.result.suspender) {
      this.pushNomeValor('Observação sobre a suspensão', this.result.mensagemSuspensao, dados);
    }



    return dados;
  }

  private pushNomeValor(nome, valor, lista) {
    lista.push({
      nome: nome, valor: valor
    });
  }

  private getDados() {
    let dados = [];
    if (!this.result || !this.result.medidas) {
      return [];
    }
    this.result.medidas.forEach((m) => {
      m.insumos
        //.filter((ins) => !!ins.quantidadeEnteral && ins.quantidadeEnteral > 0)
        .filter((ins) => ins.quantidadeEnteral != null)
        .forEach((ins) => {
          let reg: any = new Object();
          reg.codProduto = m.codProduto;
          reg.nomeProduto = m.nomeProduto;
          reg.nomeInsumo = ins.insumo + ` (${ins.unidadeMedida})`;
          reg.enteral = this.decimalFormatHelper(ins.quantidadeEnteral);
          reg.termogenese = this.decimalFormatHelper(ins.quantidadeTermogenese);
          reg.parenteral = this.decimalFormatHelper(ins.quantidade);
          reg.parenteralPerc = this.decimalFormatHelper((ins.quantidade / (ins.quantidade + ins.quantidadeEnteral)) * 100);
          reg.total = this.decimalFormatHelper(ins.quantidade + ins.quantidadeEnteral);
          dados.push(reg);          
        });
    });
    dados.sort((a, b) => {
      if (a.nomeInsumo == b.nomeInsumo) {
        return String(a.nomeProduto).localeCompare(b.nomeProduto);
      } else {
        return String(a.nomeInsumo).localeCompare(b.nomeInsumo);
      }
    });
    return dados;
  }

  private close() {
    this.$emit('close');
  }
}
